import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge30 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='名門・高額帯クラブの相場動向' fontWeight={700} />
                <p>
                    ゴルフ会員権の価格帯は10万円以下のものから4,000万円を超えるものまで幅広く存在することは
                    <a href='/knowledge/13'>こちら</a>
                    でもご紹介したとおりですが、価格帯が高いクラブには共通する特徴があります。本記事では、いわゆる「名門クラブ」と呼ばれる高額帯クラブの特徴と、相場の動向を左右する要素を解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='名門クラブと呼ばれるクラブの共通点' fontWeight={700} />

                <Heading3 title='開場からの歴史の長さ' />
                <p>
                    戦前・戦後間もない時期に開場し、長い歴史の中で会員コミュニティを育んできたクラブは、伝統やブランド力が価格に反映されやすい傾向があります。
                </p>

                <Heading3 title='会員数を絞った運営方針' />
                <p>
                    名門クラブの多くは、コースコンディションやプレー環境を維持するため、意図的に会員数を制限して運営しています。供給が限られているため、需要が集中した際に価格が高値で推移しやすくなります。
                </p>

                <Heading3 title='厳格な入会審査' />
                <p>
                    紹介制や複数名の推薦人を必要とするなど、入会審査が厳格なクラブが多いことも特徴です。推薦状に関する基本的な考え方は
                    <a href='/knowledge/18'>推薦状の文例</a>
                    でもご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='高額帯クラブの相場を動かす要素' fontWeight={700} />
                <p>
                    名門・高額帯クラブの相場は、一般的なクラブと比べて売買の絶対件数が少ないため、以下のような要素の影響を受けやすいという特徴があります。
                    <br />
                    <br />
                    ・預託金の据置期間や返還条件の見直し
                    <br />
                    ・会員の高齢化にともなう相続・譲渡の増減
                    <br />
                    ・周辺エリアの再開発や都市計画の動向
                    <br />
                    ・運営会社の資本異動や経営方針の変更
                </p>
                <p>
                    こうした要素は個々のクラブによって大きく異なるため、一般論だけで相場を判断するのではなく、最新の取引状況を確認することが重要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='名門クラブの会員権を検討する際の注意点' fontWeight={700} />
                <p>
                    名門クラブは取引価格に加えて預託金の負担も大きくなりやすいため、購入時にかかる総額を事前にしっかり把握しておくことが大切です。総額の考え方は
                    <a href='/knowledge/13'>ゴルフ会員権を安く買う方法は？ご入会にかかる総額について</a>
                    で解説しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    名門・高額帯クラブの相場は、歴史・会員数政策・入会審査の厳格さといった希少性を生む要素によって支えられています。個別クラブの最新の取引状況については、住地ゴルフまでお気軽にお問合せください。
                    <br />
                    全国的な相場の考え方は<a href='/knowledge/25'>こちら</a>もあわせてご確認ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge30;
